import { render, staticRenderFns } from "./tbqr.vue?vue&type=template&id=3d52db26&scoped=true"
import script from "./tbqr.vue?vue&type=script&lang=js"
export * from "./tbqr.vue?vue&type=script&lang=js"
import style0 from "./tbqr.vue?vue&type=style&index=0&id=3d52db26&prod&lang=less"
import style1 from "./tbqr.vue?vue&type=style&index=1&id=3d52db26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d52db26",
  null
  
)

export default component.exports